import React, { useEffect } from 'react'
import EandOForm from './EandOForm.component'
import { MDBRow } from 'mdbreact'
import UserProfileService from './../../../shared/services/UserProfile.service'
import EopolicyStore from './Eopolicy.store'

import './AgentEandOManager.scss'

const AgentEandOManager = (props) => {
  const userId = UserProfileService.getUserId(),
    { initUser } = EopolicyStore

  useEffect(() => {
    UserProfileService.instance().then((User) => initUser(User))
  }, [userId, initUser])

  return (
    <MDBRow id="AgentEandOManagerComponent">
      <EandOForm autoSave={!!props?.autoSave} onAutoSave={props?.onAutoSave} />
    </MDBRow>
  )
}

export default AgentEandOManager
